import { render, staticRenderFns } from "./Code.vue?vue&type=template&id=1ee9f0d4&scoped=true"
import script from "./Code.vue?vue&type=script&lang=js"
export * from "./Code.vue?vue&type=script&lang=js"
import style0 from "./Code.vue?vue&type=style&index=0&id=1ee9f0d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee9f0d4",
  null
  
)

export default component.exports